import { CommonUtils } from './CommonUtils';
import { LoanStatus } from './LoanData';

export type PropertyAddressLike = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zip?: string;
} | null | undefined;

export function getFirstName(name?: string | null, fallback = 'there'): string {
  const first = (name || '').trim().split(/\s+/)[0];
  return first || fallback;
}

export function formatPropertyAddress(address: PropertyAddressLike, stateOverride?: string): string {
  const state = stateOverride ?? address?.state;
  return CommonUtils.fullAddress(address?.line1, address?.line2, address?.city, state, address?.zip);
}

// Wraps email CTA destinations with sign-in so magic-link auth can return to the target route.
function buildSignInUrl(redirectTarget?: string | null): string {
  const baseUrl = `${window.location.origin}/signin`;
  const trimmedRedirectTarget = String(redirectTarget || '').trim();

  if (!trimmedRedirectTarget) return baseUrl;

  return `${baseUrl}?redirect=${encodeURIComponent(trimmedRedirectTarget)}`;
}

// Builds the existing overview/terms email redirect while sharing the sign-in wrapper.
export function buildOverviewSignInUrl(loanId?: string | null, loanStatus?: string | null): string {
  const trimmedLoanId = String(loanId || '').trim();

  if (!trimmedLoanId) return buildSignInUrl();

  const redirectTarget = loanStatus === LoanStatus.PARTIALLY_QUALIFIED
    ? `/loanapp/loan-terms?loanid=${encodeURIComponent(trimmedLoanId)}`
    : `/loanapp/overview?loanid=${encodeURIComponent(trimmedLoanId)}`;
  return buildSignInUrl(redirectTarget);
}

// Builds the authenticated deep link for disclosure-signing email CTAs.
export function buildESignSignInUrl(loanId?: string | null): string {
  const trimmedLoanId = String(loanId || '').trim();

  if (!trimmedLoanId) return buildSignInUrl();

  return buildSignInUrl(`/loanapp/esign?loanid=${encodeURIComponent(trimmedLoanId)}`);
}
